export const PROMOTIONS = 'promotions';
